import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Layout,
  message,
  Row,
  Select,
  Switch,
} from 'antd';
import React from 'react';
import ReactInputMask from 'react-input-mask';
import { Link, Navigate } from 'react-router-dom';
import {
  getToken,
  POST_API,
  POST_CATCH,
  titleWeb,
  verifyConfig,
} from '../../../services/api';
// CONTROLLER
import Page403 from '../../Controller/Page403';
import PageLoad from '../../Controller/PageLoad';

class AdminUsuarioForm extends React.Component {
  state = {
    _navigate: false,
    _loading: false,
    _screen: true,
    _params: window.location.href.split('/'),
    defaultValue: null,
    doc: false,
    filter: { CREDENTIAL_TYPE_ID: [] },
  };

  back = '/painel/usuarios';

  routes = [
    { title: <Link to={this.back}>Usuários</Link> },
    { title: this.props.type === 'add' ? 'Adicionar' : 'Editar' },
  ];

  componentDidMount = () => {
    titleWeb('Usuários');
    POST_API('/credential_type/search.php', {
      token: getToken(),
      type: 'filter',
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          this.setState({ filter: { CREDENTIAL_TYPE_ID: res.data } });
        } else {
          message.warning({ content: res.msg, key: 'screen' });
        }
      })
      .catch(() => POST_CATCH());
    if (this.props.type === 'add') {
      this.setState({ _screen: false });
    } else if (this.props.type === 'edit') {
      this.onView();
    }
  };

  onView = async () => {
    POST_API('/credential/search.php', {
      token: getToken(),
      type: 'view',
      filter: JSON.stringify({ ID: this.state._params[5] }),
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          this.setState({ defaultValue: res.data });
        } else {
          message.warning({ content: res.msg, key: 'screen' });
        }
      })
      .catch(() => POST_CATCH())
      .finally(() => this.setState({ _screen: false }));
  };

  onSend = (values) => {
    this.setState({ _loading: true });
    POST_API('/credential/save.php', {
      token: getToken(),
      type: this.props.type,
      master: JSON.stringify(values),
    })
      .then((rs) => rs.json())
      .then((res) => {
        if (res.return) {
          message.success({ content: res.msg, key: 'screen' });
          this.setState({ _navigate: true });
        } else {
          message.warning({ content: res.msg, key: 'screen' });
        }
      })
      .catch(() => POST_CATCH())
      .finally(() => this.setState({ _loading: false }));
  };

  render = () => {
    if (this.state._navigate) return <Navigate to={this.back} />;
    if (!verifyConfig(`${this.props.per}.${this.props.type}`))
      return <Page403 />;

    return (
      <Layout>
        <Layout.Content className={'admin-container'}>
          <Row align={'middle'} gutter={[8, 8]}>
            <Col span={18}>
              <Breadcrumb items={this.routes} />
            </Col>
            <Col
              span={6}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <Link to={this.back}>
                <Button
                  className="sys-btn-primary sys-btn-small"
                  shape="round"
                  size="small"
                  type="primary"
                >
                  Voltar
                </Button>
              </Link>
            </Col>
            {this.state._screen ? (
              <PageLoad />
            ) : (
              <Col span={24}>
                <Form
                  className={'admin-form'}
                  initialValues={this.state.defaultValue}
                  layout="vertical"
                  onFinish={this.onSend}
                >
                  <Form.Item hidden name="ID">
                    <Input />
                  </Form.Item>
                  <Row gutter={[16, 0]}>
                    <Col md={6} xs={24}>
                      <Form.Item
                        label={this.state.doc ? 'CNPJ' : 'CPF'}
                        name="LOGIN"
                        rules={[
                          { required: true, message: 'Campo obrigatório*' },
                        ]}
                      >
                        <ReactInputMask
                          className="ant-input css-dev-only-do-not-override-w8mnev css-w8mnev"
                          mask={
                            this.state.doc
                              ? '99.999.999/9999-99'
                              : '999.999.999-99'
                          }
                          maskChar={''}
                          maxLength={this.state.doc ? 18 : 14}
                          placeholder={this.state.doc ? 'CNPJ' : 'CPF'}
                        >
                          {(props) => <Input {...props} />}
                        </ReactInputMask>
                      </Form.Item>
                      <Switch
                        checkedChildren="CNPJ"
                        onChange={(v) => this.setState({ doc: v })}
                        style={{ position: 'absolute', right: 13, top: 35 }}
                        unCheckedChildren="CPF"
                      />
                    </Col>
                    <Col md={10} xs={24}>
                      <Form.Item
                        label="Nome"
                        name="NAME"
                        rules={[
                          { required: true, message: 'Campo obrigatório*' },
                        ]}
                      >
                        <Input type="text" />
                      </Form.Item>
                    </Col>
                    <Col md={8} xs={24}>
                      <Form.Item
                        label="Tipo de Usuário"
                        name="CREDENTIAL_TYPE_ID"
                        rules={[
                          { required: true, message: 'Campo obrigatório*' },
                        ]}
                      >
                        <Select>
                          {this.state.filter.CREDENTIAL_TYPE_ID.map((v, i) => (
                            <Select.Option key={i} value={v.ID}>
                              {v.NAME}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col md={24} xs={24}>
                      <Button
                        className="float-right"
                        htmlType="submit"
                        loading={this.state._loading}
                        shape="round"
                        type="primary"
                      >
                        Salvar
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Col>
            )}
          </Row>
        </Layout.Content>
      </Layout>
    );
  };
}

export default AdminUsuarioForm;
